/* Krokem free shipping progress bar — native replacement for
   "Essential Free Shipping Upsell". Vanilla, no dependencies.

   Visibility rules (mirrors Essential's defaults):
     - empty cart (subtotal 0) -> hidden entirely, no copy
     - below threshold         -> "You're $X away from FREE shipping!"
     - reached                 -> congrats state, unless show-reached is off
     - Pickup selected on cart -> hidden (no shipping involved)
   The container is always in the DOM when the placement is enabled, so it can
   appear live after the first add-to-cart without a page reload. */
(function () {
  'use strict';

  var SEL = '[data-krokem-shipbar]';

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var s = v.toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return '$' + s;
  }

  /* Pickup rule: on the cart page a "Pickup" shipping method means no
     shipping at all, so the bar is meaningless — hide every bar. */
  function pickupSelected() {
    var sel = document.querySelector('.shipping-method-tybo');
    return !!(sel && sel.value === 'Pickup');
  }

  function render(el, subtotal, pickup) {
    subtotal = Number(subtotal) || 0;
    if (typeof pickup !== 'boolean') pickup = pickupSelected();

    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    var remaining = Math.max(threshold - subtotal, 0);
    var reached = threshold > 0 && subtotal >= threshold;
    var showReached = el.getAttribute('data-show-reached') !== 'false';

    /* nothing at all while the cart is empty */
    var hide = subtotal <= 0 || pickup || (reached && !showReached);

    if (hide) {
      el.setAttribute('hidden', '');
      var emptyMsg = el.querySelector('[data-krokem-shipbar-msg]');
      if (subtotal <= 0 && emptyMsg) emptyMsg.textContent = '';
      return;
    }
    var wasHidden = el.hasAttribute('hidden');
    el.removeAttribute('hidden');

    var pct = threshold > 0 ? Math.min((subtotal / threshold) * 100, 100) : 100;
    if (!isFinite(pct) || pct < 0) pct = 0;
    var tpl = reached
      ? el.getAttribute('data-msg-reached') || ''
      : el.getAttribute('data-msg-progress') || '';

    var msg = tpl
      .replace(/\{remaining\}/g, money(remaining))
      .replace(/\{threshold\}/g, money(threshold));

    var msgEl = el.querySelector('[data-krokem-shipbar-msg]');
    if (msgEl && msgEl.textContent !== msg) msgEl.textContent = msg;

    var fill = el.querySelector('[data-krokem-shipbar-fill]');
    if (fill) {
      /* When the bar was just revealed there is no previous layout for the
         CSS width transition to animate from, and the fill can stay visually
         at 0. Force a reflow while visible, then apply the width. */
      if (wasHidden) {
        fill.style.transition = 'none';
        fill.style.width = '0%';
        void fill.offsetWidth; // flush layout
        fill.style.transition = '';
      }
      fill.style.width = pct + '%';
    }

    el.classList.toggle('is-reached', reached);

    var icon = el.querySelector('.krokem-shipbar__icon');
    if (icon) {
      var want = reached ? '🎉' : '🚚';
      if (icon.textContent.trim() !== want) icon.textContent = want;
    }
  }

  function renderAll(subtotal) {
    var pickup = pickupSelected();
    document.querySelectorAll(SEL).forEach(function (el) {
      render(el, subtotal, pickup);
    });
  }

  var lastSubtotal = null;

  function update(cart) {
    if (!document.querySelector(SEL)) return;
    if (!cart || typeof cart.items_subtotal_price !== 'number') {
      fetchCart();
      return;
    }
    lastSubtotal = cart.items_subtotal_price;
    renderAll(lastSubtotal);
  }

  var fetching = false;
  function fetchCart() {
    if (fetching) return;
    fetching = true;
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        fetching = false;
        lastSubtotal = cart.items_subtotal_price;
        renderAll(lastSubtotal);
      })
      .catch(function () { fetching = false; });
  }

  /* Re-apply visibility using the subtotal we already know (no refetch). */
  function reapply() {
    if (lastSubtotal === null) fetchCart();
    else renderAll(lastSubtotal);
  }

  window.KrokemShipBar = {
    update: update,
    refresh: fetchCart,
    render: render,
    reapply: reapply,
  };

  /* --- cartUpdate subscription (guard for script load order) --- */
  var subscribed = false;
  function trySubscribe() {
    if (subscribed) return;
    if (typeof subscribe !== 'function') return;
    var name =
      (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
    subscribe(name, function (event) {
      /* product-form publishes the add-to-cart RESPONSE (a line item), which
         has no items_subtotal_price — update() then falls back to /cart.js. */
      update(event && event.cartData);
    });
    subscribed = true;
  }
  trySubscribe();
  document.addEventListener('DOMContentLoaded', trySubscribe);
  window.addEventListener('load', trySubscribe);

  /* --- Drawer re-render: section rendering replaces innerHTML, so the Liquid
         markup is already fresh; we still refetch to correct stale cached
         HTML and to re-apply the pickup rule. --- */
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__krokemObserved) return;
    drawer.__krokemObserved = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(fetchCart, 60);
    }).observe(drawer, { childList: true, subtree: true });
  }

  /* --- Pickup selector is re-rendered with the cart footer section, so
         delegate at document level. --- */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('shipping-method-tybo')) {
      reapply();
    }
  });

  function init() {
    watchDrawer();
    fetchCart(); // correct stale cached HTML
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
